import React from 'react';
import { cn } from '@/lib/utils';

type SectionHeaderProps = {
  sl: string;
  primaryText: string;
  secondaryText: string;
  className?: string;
};

const SectionHeader: React.FC<SectionHeaderProps> = ({
  sl,
  primaryText,
  secondaryText,
  className,
}) => {
  return (
    <div
      className={cn(
        'padding-x-header mt-0 grid border-t pt-10 pb-10 font-mono md:grid-cols-2 md:pb-30',
        className,
      )}>
      <div className="flex gap-[10vw] text-2xl font-medium tracking-widest uppercase md:gap-[14vw] md:text-3xl">
        <div className={'text-title'}>{sl}</div>
        <div className={'flex flex-col gap-1'}>
          <div className={'text-title'}>{primaryText}</div>
          <div className="text-subtitle block text-start text-xs font-semibold uppercase md:hidden md:self-end">
            {secondaryText}
          </div>
        </div>
      </div>
      <div className="text-subtitle mb-1 hidden self-end text-end text-sm font-semibold uppercase md:block">
        {secondaryText}
      </div>
    </div>
  );
};

export default SectionHeader;
